import { render, staticRenderFns } from "./authPop.vue?vue&type=template&id=707e90f5&scoped=true"
import script from "./authPop.vue?vue&type=script&lang=js"
export * from "./authPop.vue?vue&type=script&lang=js"
import style0 from "./authPop.vue?vue&type=style&index=0&id=707e90f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e90f5",
  null
  
)

export default component.exports